import { render, staticRenderFns } from "./RentalIncome.vue?vue&type=template&id=3fa18e8a&scoped=true&"
import script from "./RentalIncome.vue?vue&type=script&lang=js&"
export * from "./RentalIncome.vue?vue&type=script&lang=js&"
import style0 from "./RentalIncome.vue?vue&type=style&index=0&id=3fa18e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa18e8a",
  null
  
)

export default component.exports